module.exports = __webpack_public_path__ + "img/tmp-patients-status-0.693d543c.svg";